import * as React from 'react'

const WritingGuideIcon = (props) => (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.82353 11L8.64706 9.75V2.25C8.64706 1.54937 9.16412 1 9.82353 1C10.4829 1 11 1.54937 11 2.25V9.75L9.82353 11ZM9.82353 11H2.17647C1.86445 11 1.56521 10.8683 1.34458 10.6339C1.12395 10.3995 1 10.0815 1 9.75C1 9.41848 1.12395 9.10054 1.34458 8.86612C1.56521 8.6317 1.86445 8.5 2.17647 8.5H4.52941C4.84143 8.5 5.14067 8.3683 5.3613 8.13388C5.58193 7.89946 5.70588 7.58152 5.70588 7.25C5.70588 6.91848 5.58193 6.60054 5.3613 6.36612C5.14067 6.1317 4.84143 6 4.52941 6H2.76471M8.64706 3.5H11"
      stroke="#545454"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default WritingGuideIcon
